import { gql } from '@apollo/client';
import { itemsFragment } from '../fragments/items';

export const searchVippedItemsQuery = gql`
  query SearchVippedItems(
    $limit: Limit!
    $filter: ItemFilter
    $sort: ItemSort!
  ) {
    items(limit: $limit, filter: $filter, sort: $sort) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;

export const searchVippedResidencesItemsQuery = gql`
  query SearchVippedResidencesItems(
    $limit: Limit!
    $filter: ItemFilter
    $sort: ItemSort!
  ) {
    items(limit: $limit, filter: $filter, sort: $sort) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;
